<template>
  <div>
    <el-collapse v-if="!isEditing" v-model="activeNames">
      <el-collapse-item title="锚点选项" name="1">
        <template slot="title">
          <span>锚点选项</span>
          <i
            v-if="!options.noteEditorAnchor && !options.fullScrollAnchor"
            class="total-num-btn icon-portal-plus"
            @click.stop="addAnchor"
          ></i>
        </template>
        <div class="drag-box">
          <draggable
            element="ul"
            v-model="tempAnchorList"
            handle=".mover"
            ghost-class="ghost"
            chosen-class="chosen"
            @start="startDrag"
            @end="endDrag"
            filter=".disabled"
          >
            <anchor-option
              :options="options"
              :anchorList="tempAnchorList"
              :dragging="dragging"
              @update="updateView"
              @edit="editAnchor"
            />
          </draggable>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div v-else class="label_edit">
      <div class="label_edit_title">
        <span class="setting_label">选项</span>
        <div>
          <el-button size="mini" class="cancel_btn" @click="onCancel">取消</el-button>
          <el-button size="mini" type="primary" @click="onSave">保存</el-button>
        </div>
      </div>
      <div class="content">
        <div class="content-item fs14 verticallyCenter mb12">
          <span class="mr12">名称</span>
          <el-input style="width: 172px; height: 32px" v-model="editingContent" placeholder="请输入" maxLength="40" />
        </div>
        <div class="content-item fs14 verticallyCenter">
          <span class="mr12">滚动到</span>
          <div class="flex1 rectTreeWrap" :class="showRectTree ? 'zIndex9999' : ''">
            <div class="rect-tree-inp">
              <input
                class="selected-rect"
                type="text"
                readonly
                :value="editingTarget ? editingTarget.label : ''"
                @click.stop="showRectTree = !showRectTree"
              />
              <span :class="showRectTree ? 'icon-portal-arrows-down rotate180' : 'icon-portal-arrows-down'"></span>
            </div>
            <chooseComponent
              v-show="showRectTree"
              class="rectTree"
              :isShow="showRectTree"
              :checkedIds.sync="editingTarget"
              @click.stop
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable"
import chooseComponent from "./setting/chooseComponent.vue"
import anchorOption from "./setting/anchorOption.vue"
import { simpleDeepClone } from "../../../utils"

export default {
  name: "anchor-options-data",
  props: { options: Object },
  components: {
    draggable,
    chooseComponent,
    anchorOption
  },
  data() {
    return {
      activeNames: ["1"],
      allAnchor: [],
      dragging: false,
      isEditing: false,
      editingIndex: "0",
      showRectTree: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    tempAnchorList: {
      get() {
        return simpleDeepClone(this.options.anchorList)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorList", false)
      }
    },
    anchorList: {
      get() {
        return this.options.anchorList
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorList", false)
      }
    },
    editItem() {
      let arr = this.editingIndex.split("_")
      let obj = this.tempAnchorList
      let child = this.tempAnchorList
      while (arr.length > 0) {
        let idx = arr.shift()
        obj = child[idx]
        child = obj.children
      }
      return obj
    },
    editingContent: {
      get() {
        return this.editItem.content
      },
      set(newVal) {
        this.editItem.content = newVal
        this.anchorList = this.tempAnchorList
      }
    },
    editingTarget: {
      get() {
        return this.editItem.target
      },
      set(newVal) {
        this.editItem.target = newVal
        this.anchorList = this.tempAnchorList
      }
    }
  },
  methods: {
    addAnchor() {
      const index = this.tempAnchorList.length + 1
      this.tempAnchorList.push({ content: `锚点${index}`, target: null, hide: false, children: [] })
      this.anchorList = this.tempAnchorList
    },
    startDrag() {
      this.dragging = true
    },
    endDrag() {
      this.dragging = false
    },
    editAnchor(path) {
      this.isEditing = true
      this.editingIndex = path
      this.originalContent = simpleDeepClone(this.editingContent)
      this.originalTarget = simpleDeepClone(this.editingTarget)
    },
    onCancel() {
      this.editItem.content = this.originalContent
      this.editItem.target = this.originalTarget
      this.anchorList = this.tempAnchorList
      this.isEditing = false
      this.editingIndex = "0"
      this.showRectTree = false
    },
    onSave() {
      this.isEditing = false
      this.editingIndex = "0"
      this.showRectTree = false
      this.$eventBus.$emit("set-anchorId", this.anchorList)
    },
    updateView() {
      this.anchorList = this.tempAnchorList
      if (!this.options.noteEditorAnchor) {
        this.$eventBus.$emit("set-anchorId", this.anchorList)
      }
    }
  }
}
</script>
<style lang="scss">
.total-num-btn {
  font-size: 16px;
  color: rgba(43, 103, 255, 1);
  margin-left: auto;
}
.label_edit {
  .label_edit_title {
    height: 44px;
    background: #f0f0f0;
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .setting_label {
      font-weight: 600;
    }
    ::v-deep .el-button--mini {
      height: 28px;
      width: 50px;
      padding: 7px 13px;
    }
    .cancel_btn {
      color: rgba(0, 0, 0, 0.8);
      border-color: rgba(0, 0, 0, 0.14);
      background-color: rgba(0, 0, 0, 0);
      &:hover {
        color: var(--themeColor);
        border-color: var(--themeColor);
      }
    }
  }
  .content {
    padding: 12px 16px;
    .content-item {
      & > span {
        width: 44px;
      }
    }
  }
  .selected-rect {
    padding: 0 12px;
    background: #f3f3f3;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 32px;
    width: 100%;
    cursor: pointer;
    box-sizing: border-box;
  }
  .rectTreeWrap {
    position: relative;
    &.zIndex9999 {
      z-index: 9999;
    }
    .rectTree {
      position: absolute;
      top: 32px;
      left: 0;
      width: 100%;
      background-color: #fff;
      box-shadow: 0 6px 24px rgba(31, 35, 41, 0.1);
      padding: 8px;
      box-sizing: border-box;
      z-index: 2;
    }
  }
  .rect-tree-inp {
    position: relative;
    .icon-portal-arrows-down {
      position: absolute;
      right: 8px;
      top: 8px;
      font-size: 16px;
      pointer-events: none;
      cursor: pointer;
      transition: all 0.5s;
    }
    .rotate180 {
      transform: rotate(180deg);
    }
  }
}
</style>
